import { Component, OnInit } from "@angular/core";
import { TraceClassDecorator } from "@sentry/angular";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { UtilitiesService } from "src/app/utilities/utilities.service";


@Component({
    selector: "app-access-denied",
    templateUrl: "./access-denied.component.html",
    styleUrls: ["./access-denied.component.css"],
})
@TraceClassDecorator()
export class AccessDeniedComponent {
    slug: string = "";
    logo_url: string = "";
    constructor(
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }
    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
    }


}
